import httpService from "../../interceptors/http";

export const postBuyerDetails = async ({ userId, buyerData }) => {
  return httpService().post(`/user`, { ...buyerData });
};
